import Vue from "vue";
import VueRouter from "vue-router";
import ELogin from "@/views/ELogin.vue";
import ReadHome from "@/views/ReadHome.vue";
import ArticleRead from "@/views/ArticleRead.vue";
import UserInfo from "@/views/UserInfo.vue";
import WordBook from "@/views/WordBook.vue";

Vue.use(VueRouter);

// 全部全屏独占页面：登录、阅读详情、用户信息、生词本
export const fullPageRoutes = ["/login", "/article", "/userinfo", "/wordbook","/admin"];

const routes = [
  {
    path: "/",
    redirect: "/read"
  },
  {
    path: "/login",
    component: ELogin
  },
  // 短文列表首页（侧边菜单显示）
  {
    path: "/read",
    component: ReadHome,
    meta: { requireLogin: true }
  },
  // 单篇阅读详情（全屏独占）
  {
    path: "/article/:id",
    component: ArticleRead,
    props: true, // 新增
    meta: { requireLogin: true }
  },
  // 用户信息页（全屏独占）
  {
    path: "/userinfo",
    component: UserInfo,
    meta: { requireLogin: true }
  },
  // 生词本（全屏独占）
  {
    path: "/wordbook",
    component: WordBook,
    meta: { requireLogin: true }
  },
  {
    path: '/admin',
    name: 'AdminManage',
    component: () => import('@/views/AdminManage.vue'),
    meta: {
      fullPage: true // 全局判断，侧边栏v-if="$route.name !== 'ArticleRead' && $route.name !== 'Admin'"
    }
  }
];

const router = new VueRouter({
  routes
});

// 登录鉴权守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("readerToken");
  if (to.meta.requireLogin) {
    token ? next() : next("/login");
  } else {
    next();
  }
});

export default router;